(function () {
  var KEY = 'fiorenci_recent';   // sessionStorage: array of product handles, newest first. Handles only, nothing else.
  var MAX_STORED = 8;   // current product + the 6 shown + 1 spare to refill a gap
  var MAX_SHOWN = 6;   // one scrolling row: 4 visible on a computer, 2 on a phone

  var root = document.querySelector('[data-recent-viewed]');
  if (!root || root.getAttribute('data-recent-init')) return;
  root.setAttribute('data-recent-init', '1');

  var current = root.getAttribute('data-handle');
  var sectionId = root.getAttribute('data-section-id');
  // routes.root_url is "/" in English but "/sv" (no trailing slash) in Swedish.
  var base = (root.getAttribute('data-root') || '/').replace(/\/?$/, '/');

  function isHandle(h) { return typeof h === 'string' && h.length > 0 && h.length < 256 && !/[\/?#\s]/.test(h); }

  // sessionStorage can be blocked (private modes, strict settings): every access is wrapped, and the
  // page simply shows no row when it is.
  function read() {
    try {
      var a = JSON.parse(window.sessionStorage.getItem(KEY));
      return Array.isArray(a) ? a.filter(isHandle) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { window.sessionStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORED))); } catch (e) {}
  }

  // 1. Record this product right away (to the front, no duplicates), before anything is fetched.
  if (!isHandle(current)) return;
  var stored = read().filter(function (h) { return h !== current; });
  stored.unshift(current);
  write(stored);

  // 2. Everything else waits until the page has loaded: the row is below the fold and must not compete
  //    with the main content.
  function fetchCard(handle) {
    var url = base + 'products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(sectionId);
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (res.status === 404 || res.status === 410) return { handle: handle, gone: true };
      if (!res.ok) return { handle: handle, failed: true };
      return res.text().then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var tpl = doc.querySelector('template[data-recent-card]');
        var card = tpl && tpl.content.querySelector('.f-card');
        if (card && card.getAttribute('data-product-id')) return { handle: handle, card: card };
        // For a product that no longer exists Shopify answers 200 and renders the section with an empty
        // product: the section is there but it has no card. Anything else (no section at all) is a failed request.
        return doc.querySelector('[data-recent-viewed]') ? { handle: handle, gone: true } : { handle: handle, failed: true };
      });
    }).catch(function () { return { handle: handle, failed: true }; });
  }

  // Arrows (computers only; hidden by CSS on phones, where the row is swiped): real buttons that scroll the row by
  // one "page" of cards, hidden when there is nothing further to reveal in that direction.
  function setupArrows(list) {
    var prev = root.querySelector('[data-recent-prev]');
    var next = root.querySelector('[data-recent-next]');
    if (!prev || !next) return;
    function update() {
      var max = list.scrollWidth - list.clientWidth;
      prev.hidden = !(max > 2 && list.scrollLeft > 2);
      next.hidden = !(max > 2 && list.scrollLeft < max - 2);
    }
    function page(dir) {
      var first = list.querySelector('li');
      var step = first ? (first.getBoundingClientRect().width + 24) * 2 : list.clientWidth;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      list.scrollBy({ left: dir * step, behavior: reduce ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function run() {
    var pending = read().filter(function (h) { return h !== current; });
    var shown = [];
    var gone = {};
    var seenIds = {};

    function finish() {
      var dead = Object.keys(gone);
      if (dead.length) write(read().filter(function (h) { return !gone[h]; }));   // a deleted/unpublished product disappears quietly
      if (!shown.length) return;                                                 // nothing to show: no heading, no space
      var list = root.querySelector('.f-recent__list');
      shown.forEach(function (r) {
        var li = document.createElement('li');
        li.appendChild(document.importNode(r.card, true));
        list.appendChild(li);
      });
      root.hidden = false;
      setupArrows(list);
      document.dispatchEvent(new CustomEvent('fiorenci:cards-added'));            // wishlist.js repaints the hearts
    }

    // Ask for as many cards as are still missing; if some are gone, older handles refill the row.
    function next() {
      var need = MAX_SHOWN - shown.length;
      if (need <= 0 || !pending.length) return finish();
      Promise.all(pending.splice(0, need).map(fetchCard)).then(function (results) {
        results.forEach(function (r) {
          if (r.gone) { gone[r.handle] = true; return; }
          if (!r.card) return;
          var id = r.card.getAttribute('data-product-id');
          if (id && seenIds[id]) return;                                          // same product under an old handle
          if (id) seenIds[id] = true;
          shown.push(r);
        });
        next();
      });
    }
    next();
  }

  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run);
})();
